import { formatDate } from "./dateHelper";
import { SurveyType } from "./enumsHelper";

export const getSurveyReportPdfName = (surveyType, isSecondSignature, t) => {
  let baseName = '';

  if (surveyType ===  SurveyType.Delivery) {
    baseName = isSecondSignature
      ? 'PvO_met_tweede_handtekening_'
      : 'PvO_';
  } else if (surveyType === SurveyType.PreDelivery) {
    baseName = t('general.preDeliveryReport') + '_';
  } else {
    baseName = t('survey.inspection') + '_';
  }

  const dateStr = formatDate(new Date());
  const timestamp = new Date().getTime();

  return `${baseName}${dateStr}_${timestamp}.pdf`;
};